import React from "react";
import {
  Create,
  SimpleForm,
  NumberInput,
  TextInput,
  SimpleFormIterator,
  ArrayInput,
  AutocompleteInput,
  ReferenceInput,
  required,
} from "react-admin";
import { autocompleteInput_style_filter_reference } from "../../../../customStyles/ra-custom-styles";
import { MONTH_VALID, AUTORS, THEMATIC_CATALOG, SUBSCRIPTION_COMPANY } from "../../../../utils/constants";
import { Grid } from "@mui/material";

const CreateCatalog = () => {
  return (
    <Create title="Създаване на издание към каталог">
      <SimpleForm>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={4}
            lg={4}
          >
            <TextInput
              label="Заглавие"
              source="title"
              fullWidth
            />
            <TextInput
              label="Вид издание"
              source="edition_type"
              fullWidth
            />

            <TextInput
              label="kind"
              source="kind"
              fullWidth
            />
            <TextInput
              label="kat"
              source="kat"
              validate={required()}
              fullWidth
            />
            <TextInput
              label="zeroth_per"
              source="zeroth_per"
              fullWidth
            />
          </Grid>
          <Grid
            item
            md={4}
            lg={4}
          >
            <TextInput
              label="first_per"
              source="first_per"
              fullWidth
            />
            <TextInput
              label="second_per"
              source="second_per"
              fullWidth
            />
            <TextInput
              label="kode"
              source="kode"
              fullWidth
            />
            <TextInput
              label="Промоция"
              source="gratis"
              validate={required()}
              fullWidth
            />
            <TextInput
              label="Код"
              source="kod"
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid
          item
          md={10}
          lg={10}
        >
          <ReferenceInput
            source="thematic_catalog_id"
            reference={THEMATIC_CATALOG}
          >
            <AutocompleteInput
              label="Тема"
              sx={autocompleteInput_style_filter_reference}
              optionText="name"
              fullWidth
            />
          </ReferenceInput>
          <ReferenceInput
            source="publisher_id"
            reference={AUTORS}
          >
            <AutocompleteInput
              label="Издател"
              sx={autocompleteInput_style_filter_reference}
              optionText="publisher_name"
              fullWidth
            />
          </ReferenceInput>
          <ReferenceInput
            source="campaign_id"
            reference={SUBSCRIPTION_COMPANY}
          >
            <AutocompleteInput
              label="Кампания"
              sx={autocompleteInput_style_filter_reference}
              optionText="name_bg"
              fullWidth
            />
          </ReferenceInput>

          <ArrayInput
            label="Абонаменти"
            source="subscriptions_prices"
            validate={required()}
          >
            <SimpleFormIterator inline>
              <NumberInput
                label="Цена в лв."
                source="price"
                margin={"dense"}
              />
              <ReferenceInput
                source="month_index"
                reference={MONTH_VALID}
              >
                <AutocompleteInput
                  label="За брой месеци"
                  sx={autocompleteInput_style_filter_reference}
                  optionText="month_index"
                />
                {/* is valid only months smaller or eaqual than current  */}
              </ReferenceInput>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

export default CreateCatalog;
